import {IAvatar} from '../Authentication/utils';


export interface IUser {
    uid: string;
    name: string;
    online: boolean;
    buddies: string[];
    blacklist: string[];
    timestamp: number;
    currentlyOn: string;
    avatar: IAvatar;
    pm_addresses?: string[];
}


export enum EMessageType {
    default = 'default',
    system = 'system',
}


export interface IMessage {
    message: string;
    sender: string;
    sender_name: string;
    timestamp: number;
    unread: boolean;
    type?: EMessageType;
    edited?: boolean;
}


export interface IRoom {
    avatar?: string;
    id: string;
    title: string;
    link?: string;
    timestamp: number;
    status?: string;
}
